import { render, staticRenderFns } from "./AmortizationTransactionReport.vue?vue&type=template&id=0229fc5f&"
import script from "./AmortizationTransactionReport.vue?vue&type=script&lang=ts&"
export * from "./AmortizationTransactionReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0229fc5f')) {
      api.createRecord('0229fc5f', component.options)
    } else {
      api.reload('0229fc5f', component.options)
    }
    module.hot.accept("./AmortizationTransactionReport.vue?vue&type=template&id=0229fc5f&", function () {
      api.rerender('0229fc5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-payables/reports/AmortizationTransactionReport.vue"
export default component.exports